var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginationLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5469_10338)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1075 8.14705C17.4181 8.45769 17.4181 8.96134 17.1075 9.27199L12.1548 14.2247L17.1075 19.1773C17.4181 19.488 17.4181 19.9916 17.1075 20.3023C16.7968 20.6129 16.2932 20.6129 15.9825 20.3023L10.4674 14.7871C10.1567 14.4765 10.1567 13.9728 10.4674 13.6622L15.9825 8.14705C16.2932 7.8364 16.7968 7.8364 17.1075 8.14705Z",
    fill: "#3E3E4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5469_10338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.0117188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationLeftArrow);
export default __webpack_public_path__ + "static/media/pagination-left-arrow.ff56c8400eb28526bed80d63fa00e4e4.svg";
export { ForwardRef as ReactComponent };